import { useState, useCallback } from 'react';
import { rsvpApi } from '@/api/rsvpApi';
import type { CreateRSVPRequest } from '@/types/api';
import { getErrorMessage, logError } from '@/utils/error';

/**
 * Хук для работы с RSVP
 */
export const useRSVP = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  /**
   * Создает RSVP ответ
   */
  const submitRSVP = useCallback(async (inviteId: string, data: CreateRSVPRequest) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await rsvpApi.create(inviteId, data);
      setSuccess(true);
      return { success: true, error: null };
    } catch (err) {
      const errorMessage = getErrorMessage(err);
      logError(err, 'useRSVP.submitRSVP');
      setError(errorMessage);
      setSuccess(false);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  }, []);

  /**
   * Сбрасывает состояние
   */
  const reset = useCallback(() => {
    setError(null);
    setSuccess(false);
    setLoading(false);
  }, []);

  return {
    loading,
    error,
    success,
    submitRSVP,
    reset,
  };
};
